import { TextKey } from '@mews-commander/enums';
import { email, presence, url, ValidationRules } from '@mews-commander/legacy-form';
import { BrandRegistrationFormValues } from './types';

type Constraints = {
    [K in keyof BrandRegistrationFormValues]?: ValidationRules;
};

interface GetAddressConstraintsOptions {
    hasCountrySubdivisions: (countryCode: string) => boolean;
    values: BrandRegistrationFormValues;
}

const getAddressConstraints = ({ hasCountrySubdivisions, values }: GetAddressConstraintsOptions): Constraints => {
    const { countryCode } = values;
    const shouldRequireCountrySubdivision = hasCountrySubdivisions(countryCode);

    return {
        addressLine1: { presence },
        city: { presence },
        postalCode: { presence },
        countryCode: { presence },
        countrySubdivisionCode: { presence: shouldRequireCountrySubdivision ? presence : undefined },
    };
};

const customerProfileConstraints: Constraints = {
    businessName: { presence },
    businessType: { presence },
    businessRegistrationIdentifier: { presence },
    businessRegionsOfOperation: { presence },
    businessRegistrationNumber: { presence },
    businessIndustry: { presence },
    websiteUrl: { presence, url },
};

const businessContactConstraints: Constraints = {
    firstName: { presence },
    lastName: { presence },
    jobTitle: { presence },
    jobPosition: { presence },
    phoneNumber: { presence },
    email: { email, presence },
};

export const getConstraints = ({ hasCountrySubdivisions, values }: GetAddressConstraintsOptions): Constraints => ({
    ...getAddressConstraints({ hasCountrySubdivisions, values }),
    ...customerProfileConstraints,
    ...businessContactConstraints,
    termsAndConditions: {
        trueValue: {
            message: TextKey.ValidateAllTermsAndConditionsChecked,
        },
    },
});
